import { render } from "./ScrollProgressBar.vue?vue&type=template&id=588a5361"
import script from "./ScrollProgressBar.vue?vue&type=script&lang=js"
export * from "./ScrollProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__